module.exports = __webpack_public_path__ + "static/media/TRIAL-1.8a6f49b0.mp3";